import React, { useEffect, useState } from 'react';
import { Button, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Grid, Typography, Select, MenuItem, Divider } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

function SurveyForm({ surveyData, surveyId, onSubmit }) {
  const [responses, setResponses] = useState({});

  // Initialize responses state when surveyData changes
  useEffect(() => {
    const initialResponses = Object.keys(surveyData).reduce((acc, questionId) => {
      acc[questionId] = '';
      return acc;
    }, {});
    setResponses(initialResponses);
  }, [surveyData]);

  const handleChange = (questionId, event) => {
    if (questionId.includes('-')) {
      const [mainQuestionId, subKey] = questionId.split('-');
      setResponses(prevResponses => ({
        ...prevResponses,
        [mainQuestionId]: {
          ...prevResponses[mainQuestionId],
          [subKey]: event.target.value,
        },
      }));
    } else {
      setResponses(prevResponses => ({
        ...prevResponses,
        [questionId]: event.target.value,
      }));
    }
  };  

  return (
    <ThemeProvider theme={theme}>
      <form onSubmit={(event) => onSubmit(event, responses)}>
        <Grid container direction="column" spacing={2} justifyContent="center" style={{ paddingLeft: '10%' }}>
        <Typography variant="h4" color="primary" gutterBottom style={{ marginTop: '20px' }}>
          {surveyId}
        </Typography>
          {Object.keys(surveyData).map((questionId, index) => {
            const questionData = surveyData[questionId];
            return (
              <Grid item xs={12} sm={8} md={6} lg={4} key={questionId} style={{ alignSelf: 'flex-start' }}>
                <FormControl component="fieldset">
                  <FormLabel component="legend" color="analogous">{index + 1}. {questionData.Prompt}</FormLabel>
                  {(() => {
                    switch (questionData.Type) {
                      case 'multiple-choice':
                        return (
                          <RadioGroup
                            aria-label={questionData.Prompt}
                            name={questionId}
                            value={responses[questionId] || ''}
                            onChange={(event) => handleChange(questionId, event)}
                          >
                            {Object.entries(questionData.Answer || {}).map(([key, answer]) => (
                              <FormControlLabel key={key} value={answer} control={<Radio />} label={answer} />
                            ))}
                          </RadioGroup>
                        );
                        case 'drop-down':
                          return (
                            <Grid container direction="column" style={{ alignSelf: 'flex-start' }}>
                              <Typography variant="subtitle1" color="analogous" align="left">
                                {questionData.Label}
                              </Typography>
                              <Select
                                value={responses[questionId] || ''}
                                onChange={(event) => handleChange(questionId, event)}
                                style={{ maxWidth: '25%' }}
                              >
                                {questionData.Answer.map((optionValue, index) => (
                                  <MenuItem key={index} value={optionValue}>{optionValue}</MenuItem>
                                ))}
                              </Select>
                            </Grid>
                          );                        
                      default:
                        return null;
                    }
                  })()}
                </FormControl>
                <Divider style={{ marginTop: '20px', marginBottom: '20px' }} />
              </Grid>
            );
          })}
          <Grid item xs={12} sm={8} md={6} lg={4} style={{ alignSelf: 'flex-start' }}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
    </ThemeProvider>
  );
}

export default SurveyForm;